document.addEventListener('DOMContentLoaded', function () {
  const desktopSideMenuTrigger = document.querySelector('.account-menu-toggle');
  const desktopSideMenuOverflow = document.getElementById('DesktopSideMenuOverflow');
  const desktopSideMenuCloseBtn = document.querySelector('.js-desktop-side-menu-close');

  const activateMenu = function () {
    document.getElementById('DesktopSideMenuOverflow').classList.add('active');
    document.getElementById('DesktopSideMenuContainer').classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  const deActivateMenu = function () {
    document.getElementById('DesktopSideMenuOverflow').classList.remove('active');
    document.getElementById('DesktopSideMenuContainer').classList.remove('active');
    document.body.style.overflow = '';
  }

  const addEventListeners = function () {
    desktopSideMenuTrigger.addEventListener('click', activateMenu);
    desktopSideMenuOverflow.addEventListener('click', deActivateMenu);
    desktopSideMenuCloseBtn.addEventListener('click', deActivateMenu);
  }

  addEventListeners();
})